import React from 'react';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import { Container } from '@mui/system';
import { Main } from 'layouts';
import Product from './components/Product';
import FullScreenHeroWithLogoGrid from './components/FullScreenHeroWithLogoGrid';
import Partners from './components/Partners';
import Team from './components/Team';
import Testimonials from './components/Testimonials/Testimonials';

const Landing = () => {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Main>
        <Box backgroundColor={theme.palette.background.level1}>
          <FullScreenHeroWithLogoGrid />
        </Box>
        <Box 
          backgroundColor={theme.palette.background.paper} 
          paddingY={10} 
          id={'promise'}
        >
          <Container>
            <Team />
          </Container>
        </Box>
        <Box 
          paddingY={5} 
          backgroundColor={theme.palette.background.level1} 
          id={'business-model'}
        >
          <Container>
            <Product />
          </Container>
        </Box>
        <Box>
          <Testimonials />
        </Box>
        <Box bgcolor="primary" paddingTop={1} id={'ally'}>
          <Partners />
        </Box>
      </Main>
    </React.Fragment>
  );
};

export default Landing;
